import React, { useState, useContext } from 'react'
import './Options.css'
import { Button, Card, Form } from 'react-bootstrap';



const Options= (props) => {
    
    const [selectedOption, setSelectedOption] = useState('');
    const [showForm, setShowForm] = useState(false);
   
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        number: '',
      });
      
  
    
    
    const options = [
        {
            label:'Flight Status',
            
            id: 1,
        },
        {
            label: 'Book a Trip',
            
            id: 2,
        },
        {
            label: 'Find Hotels',
           
            id: 3,
        },
        {
            label: 'Packing Tips',
           
            id: 4,
        },
       
        {
            label: 'Flight Deals',
           
            id: 5,
        },
        {
            label: 'Vehicle Rentals',
           
            id: 6,
        },
        {
          label: 'Find Vacation Spots',
         
          id: 7,
        },
        {
          label: 'Register',
         
          id: 8,
      }
    ];
    
    const handleOptionClick = (label) => {
        setSelectedOption(label);
        setShowForm(true);
       
      };
      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
      const handleSubmit = (e) => {
        e.preventDefault();
        
        
        if (!formData.name || !formData.email || !formData.number) {
          return; // If any field is empty, prevent form submission
        }
        // props.actionProvider.storeMessageInFirestore(formData, selectedOption);
        props.actionProvider.handleSubmit(formData, selectedOption);
       
       
        
        setShowForm(false);
       
      };
    
   
    
   
    const buttonsMarkup = options.map((option) => (
        <button key={option.id} onClick={() => handleOptionClick(option.label)}className="option-button">
            {option.label}
        </button>
    ));

    return (
    <div>
    <div className="options-container">
    {buttonsMarkup}
    </div>
    {selectedOption && (
        <Card style={{backgroundColor:'#EEEEEE'}}className='mt-4 p-3 text-align-center justify-content-center text-center align-items-center'>
          <p >You selected: {options.find((option) => option.label === selectedOption).label}</p>
            {showForm && (
          <Form className=''>
            <p>Before we proceed, provide your name, email, and number:</p>
          <Form.Control
            type="text"
            placeholder="Name" className='mb-1'
              name="name"
              value={formData.name}
              onChange={handleChange}
          />
          <Form.Control
            type="email"
            placeholder="Email address" className='mb-1'
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          <Form.Control 
            type="text" className='mb-2'
            placeholder="Phone Number"
            name="number"
              value={formData.number}
              onChange={handleChange}
          />
          <Button style={{backgroundColor:'#008080'}} onClick={handleSubmit}>Submit</Button>
          </Form>)}
          
        </Card>
      )}
    </div>
    )

}

export default Options

